import Badge from "@/components/core/badge";
import type { CaseRecord } from "@/features/case-record/types/case-records";
import { formatDate } from "@/utils/format-date";
import { IconCircleDot } from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";

export const CaseItem = ({ data }: { data: CaseRecord }) => {
	return (
		<div className="flex flex-col w-full mt-6">
			<div className="flex flex-col w-full pl-3">
				<div className="flex flex-col w-full pl-6 gap-6 border-l border-border/50">
					<div className="relative flex flex-col w-full gap-2">
						<div className="absolute right-full -top-1 mr-2 inline-flex w-[32px] h-[32px] rounded-full justify-center items-center bg-background text-primary-600">
							<IconCircleDot size={18} stroke={2} />
						</div>
						<div className="flex flex-row items-center w-full gap-2">
							<Link
								to={`/cases/${data.id}` as string}
								target="_blank"
								className="text-base font-semibold text-blue-600 hover:text-blue-500 truncate"
							>
								Case No. {data.case_number || "--"}
							</Link>
							{/* <Badge className="uppercase" size="xs" color="green-light">
								{data.stage ? data.stage : ""}
							</Badge> */}

							{data.status === "draft" ? (
								<Badge className="uppercase" size="xs" color="yellow">
									DRAFT
								</Badge>
							) : data.status === "branch_receiving" ? (
								<Badge className="uppercase" size="xs" color="yellow">
									PENDING
								</Badge>
							) : (
								<Badge
									className="uppercase"
									size="xs"
									color={data.status === "CASE_CLOSED" ? "gray" : "green-light"}
								>
									{data.stage ? data.stage : data.status}
								</Badge>
							)}
						</div>
						<div className="flex flex-col w-full rounded-md p-4 border border-border/50">
							<div className="inline-flex flex-col w-auto">
								<span className="text-base font-bold text-foreground-dark">
									{data.case_title}
								</span>
								<span className="text-base text-foreground">
									Case filed at {formatDate(data.filed_at, "PP")}
								</span>

								<span className="text-base text-foreground">{data.branch}</span>

								<span className="text-base text-foreground truncate">
									{data.case_category} - {data.case_type}
								</span>

								<span className="text-base text-foreground">
									Party Type: {data.party_type}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
